// extracted by mini-css-extract-plugin
export default {"titleIcon":"TitleBox_titleIcon__npYHe","itemTitle":"TitleBox_itemTitle__Y4r+J"};